import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccountProfile from '../modules/admin/profile';
import AdminHome from '../modules/admin/AdminHome';
import AdminStudents from '../modules/admin/students/AdminStudents';
import AdminLeadCoaches from '../modules/admin/lead/AdminLeadCoaches';
import AdminHeadCounselors from '../modules/admin/head/AdminHeadCounselors';
import AdminFACounselors from '../modules/admin/fa/AdminFACounselors';
import AddUser from '../modules/admin/AddUser';
import StudentRoutes from '../modules/admin/StudentRoutes';
import Curriculum from '../modules/admin/curriculum';
import LcProfile from '../components/lc-profile';
import HCProfile from '../components/hc-profile';
import FAProfile from '../components/fa-profile';
import Navigation from 'modules/admin/components/navigation';
import Logout from './auth/Logout';
import NotificationPage from './pages/notification/Page';
import Messages from 'components/pages/messages';
import Guardians from 'modules/admin/guardians';
import Groups from './groups';
import Meeting from './twilio/VideoChat';
import MeetingView from '../modules/admin/meeting/view';
import TimelineTemplates from '../modules/admin/timeline-templates';
import Products from '../modules/admin/products';
import LcSchedule from 'modules/hc/LcSchedule';
import Profile from 'modules/admin/profile'
import Payments from "../modules/admin/payments";
import CollegeDatabase from '../modules/admin/college-database';
import NotificationTemplates from '../modules/admin/notification-templates';
import Subscriptions from '../modules/admin/subscriptions';
import Engagement from '../modules/admin/engagement';
import TODOS from 'modules/admin/todos';
import Campaigns from 'modules/admin/campaigns/list';
import EssaysSummary from 'modules/admin/essays-summary';
import Layout from './Layout';
import { AdminSidebar } from '../constant';

class Admin extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    return (
      <Layout
        navigations={AdminSidebar}
        role="admin"
        renderHeader={({ toggleMenu}) => (
          <Navigation toggleMenu={toggleMenu} />
        )}
      >
        <Switch>
          <Route path="/profile/account" component={AccountProfile} />
          <Route exact path="/students" component={AdminStudents} />
          <Route path="/students/:id" component={StudentRoutes} />
          <Route path="/lcs/:id/profile" component={LcProfile} />
          <Route path="/lcs" component={AdminLeadCoaches} />
          <Route path="/hcs/:id/profile" component={HCProfile} />
          <Route path="/hcs" component={AdminHeadCounselors} />
          <Route path="/fas/:id/profile" component={FAProfile} />
          <Route path="/fas" component={AdminFACounselors} />
          <Route path="/guardians" component={Guardians} />
          <Route path="/create-user" component={AddUser} />
          <Route path="/curriculum" component={Curriculum} />
          <Route path="/campaigns" component={Campaigns} />
          <Route
            path="/timeline-templates"
            render={(props) => <TimelineTemplates {...props} canEdit />}
          />
          <Route
            path="/profile"
            render={(props) => <Profile {...props} user={this.props.user} />}
          />
          <Route path="/notifications" component={NotificationPage} />
          <Route exact path="/calendar" component={LcSchedule} />
          <Route path="/groups" component={Groups} />
          <Route path="/inbox" component={Messages} />
          <Route path="/products" component={Products} />
          <Route exact path={'/meeting/:roomId'} component={Meeting} />
          <Route
            exact
            path={'/meeting/group/:roomId'}
            component={(props) => <Meeting {...props} isGroup />}
          />
          <Route
            exact
            path={'/meeting/:conferenceId/view'}
            component={MeetingView}
          />
          <Route path="/payments" component={Payments} />
          <Route path="/colleges" component={CollegeDatabase} />
          <Route path="/notification-templates" component={NotificationTemplates} />
          <Route path="/subscriptions" component={Subscriptions} />
          <Route path="/todos" component={TODOS} />
          <Route path="/engagement" component={Engagement} />
          <Route path="/essays" component={EssaysSummary} />
          <Route path="/logout" component={Logout} />
          <Route exact path="/" component={AdminHome} />
        </Switch>
      </Layout>
    );
  }
}

export default Admin;
